<!--
  A run of inline children with no wrapper element and no whitespace between
  them. Written on one line for the reason given in Marked.svelte.

  With `blockId`, it also draws that block's comment highlights: the children
  are cut on the MODEL where a highlight starts or ends (lib/anchors.ts), so
  each highlight is the innermost wrapper of a text run and never straddles a
  bold, a link or a strike. After the piece where each range ends comes its
  pin: a real button naming the thread, invisible until it has keyboard focus,
  which is how a keyboard user gets from the words to their thread. It holds no
  text node, so it never shifts a selection's offsets (lib/selection.ts).
-->
<script lang="ts">
  import type { PMNode } from '../types'
  import type { BlockRange } from '../anchors'
  import { splitInlines } from '../anchors'
  import { useHighlights } from '../highlights.svelte'
  import Inline from './Inline.svelte'

  let { nodes, blockId }: { nodes: PMNode[]; blockId?: string } = $props()

  const hl = useHighlights()
  const pieces = $derived(splitInlines(nodes, hl && blockId ? hl.rangesFor(blockId) : []))

  function pinLabel(r: BlockRange): string {
    const quote = r.text.length > 60 ? `${r.text.slice(0, 59)}…` : r.text
    const state = r.state === 'handled' ? 'handled' : r.state === 'closed' ? 'closed' : 'open'
    return `Go to the ${state} comment on “${quote}”`
  }
</script>

{#each pieces as piece, i (i)}{#if piece.kind === 'inline'}<Inline node={piece.node} cover={piece.cover} />{:else}<button type="button" class="anchor-pin" data-anchor-pin data-thread-id={piece.range.threadId} data-state={piece.range.state} aria-label={pinLabel(piece.range)} onclick={() => hl?.activate(piece.range.threadId)} onfocus={() => hl && (hl.active = piece.range.threadId)} onblur={() => hl && hl.active === piece.range.threadId && (hl.active = null)}></button>{/if}{/each}
